export default __webpack_public_path__ + "static/ecomtrackNotebook-c4e0c9c6f530c9b32b6102e8819ba4de.jpg";